import { render, staticRenderFns } from "./MerchantSignAuthFile.vue?vue&type=template&id=7b284bf0&scoped=true"
import script from "./MerchantSignAuthFile.vue?vue&type=script&lang=js"
export * from "./MerchantSignAuthFile.vue?vue&type=script&lang=js"
import style0 from "./MerchantSignAuthFile.vue?vue&type=style&index=0&id=7b284bf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b284bf0",
  null
  
)

export default component.exports